import './_inner-page-banner.scss';
import { debounce } from '../../../utilities';

$(() => {
    const $bannerCircle = $('.banner__circle');
    const $bannerTop = $('.banner-top');
    if (!$bannerTop.length) {
        return;
    }
    function resize() {
        const h = $bannerCircle.outerHeight();
        $bannerTop.css('padding-bottom', `${h / 2}px`);
    }
    resize();
    window.addEventListener('resize', debounce(resize, 300));
});
